import React, { useEffect } from "react";
import { useState } from "react";
import "./Navbar.css";
import LinkImg from "../Images/Link - Corefit Plus ⏵ Untitled-design-11-1.png";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isMobile, setisMobile] = useState(false);

  const [isPopupVisible, setPopupVisible] = useState(false);
  const [amount, setAmount] = useState("");
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };



  const openGoogleForm = () => {
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLSfN8fxItN5Urk_rTdkPv4yxDiFXCEHE_N915BOLlop3OhQBMA/viewform?usp=sf_link",
      "_blank",
    );
  };

  const loadRazorpay = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  const handlePayment = async () => {
    if (!amount || isNaN(amount) || amount <= 0) {
      alert("Please enter a valid amount.");
      return;
    }

    const isLoaded = await loadRazorpay();
    if (!isLoaded) {
      alert("Razorpay SDK failed to load. Please check your internet connection.");
      return;
    }

    try {
      const API_BASE_URL = window.location.hostname === "localhost" 
        ? "http://localhost:8081" 
        : "https://corefitplus-backend.el.r.appspot.com";

      // 1. Fetch the Key from your backend
      const keyResponse = await fetch(`${API_BASE_URL}/get-razorpay-key`);
      const { key } = await keyResponse.json();

      // 2. Create the Order
      const amountInPaise = Math.round(amount * 100);
      const orderResponse = await fetch(`${API_BASE_URL}/create-order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ amount: amountInPaise }),
      });
      const order = await orderResponse.json();

      if (!order.id) {
        console.error("Order creation failed:", order);
        alert("Failed to create order. Please try again.");
        return;
      }

      console.log("Order Created:", order);

      // 3. Initialize Razorpay using the fetched key
      const options = {
        key: key,
        amount: order.amount,
        currency: order.currency,
        name: "Corewellness Pvt. Ltd.",
        description: "Corefit Plus Payment",
        order_id: order.id,
        prefill: {
          name: "Test User",
          email: "testuser@example.com",
          contact: "9999999999",
        },
        handler: async function (response) {
          console.log("Payment Successful:", response);
          try {
            const verificationResponse = await fetch(
              `${API_BASE_URL}/verify-payment`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_signature: response.razorpay_signature,
                }),
              }
            );
            const result = await verificationResponse.json();
            if (result.status === "ok") {
              alert("Payment Verified Successfully!");
            } else {
              alert("Payment Verification Failed!");
            }
          } catch (error) {
            console.error("Verification error:", error);
            alert("Payment successful but verification failed.");
          }
        },
        theme: {
          color: "#3399cc",
        },
        retry: {
          enabled: false,
        },
      };

      console.log("Razorpay Options:", options);

      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", function (response) {
        console.error("Payment Failed:", response.error);
        alert(
          "Payment Failed: " +
            (response.error.description || "Unknown error"),
        );
      });
      rzp.open();
      setPopupVisible(false); // Close popup after submission
    } catch (error) {
      console.error("Error initiating payment:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <div className="navbar">
        <div className="navbar4">
          <div className="navbar2">
            <Link to="/">
              <img src={LinkImg} alt="xxx" />
            </Link>
          </div>
          <div
            className={isMobile ? "navbar9" : "navbar3"}
            onClick={() => setisMobile(false)}
          >
            <li>
              <Link onClick={scrollToTop} className="no-underline" to="/">
                HOME
              </Link>
            </li>
            <li>
              <Link
                onClick={scrollToTop}
                className="no-underline"
                to="/aboutus"
              >
                ABOUT US
              </Link>
            </li>
            <li>
              <Link
                onClick={scrollToTop}
                className="no-underline"
                to="/Classes"
              >
                CLASSES
              </Link>
            </li>
            <li>
              <Link
                onClick={scrollToTop}
                className="no-underline"
                to="/ThePlus"
              >
                THE PLUS
              </Link>
            </li>
            <li style={{ maxWidth: "180px" }}>
              <Link
                onClick={scrollToTop}
                className="no-underline"
                to="/PilatesTeachersTraining"
              >
                TEACHER TRAINING CERTIFICATION
              </Link>
            </li>
            <li>
              <Link
                onClick={scrollToTop}
                className="no-underline"
                to="/ourstudio"
              >
                LOCATIONS
              </Link>
            </li>
            {/* <li>
              <Link onClick={scrollToTop} className="no-underline" to="/Faqs">
                FAQs
              </Link>
            </li> */}
            {/* <li>
              <Link onClick={scrollToTop} className="no-underline" to="/blog1">
                BLOG
              </Link>
            </li> */}
            <li>
              <Link
                onClick={scrollToTop}
                className="no-underline"
                to="/contactus"
              >
                CONTACT US
              </Link>
            </li>
            <button onClick={openGoogleForm}> Book a Trial Now</button>
            <button onClick={() => setPopupVisible(true)}>Pay Now</button>
          </div>
        </div>
        <div className="navbar5">
          <div className="navbar6">
            <Link to="/">
              <img src={LinkImg} alt="xxx" />
            </Link>
          </div>
          <div className="navbar7">
            <button onClick={() => setPopupVisible(true)} className="gaft">
              Pay Now
            </button>
            <button className="hm" onClick={() => setisMobile(!isMobile)}>
              {isMobile ? (
                <i className="fas fa-times"></i>
              ) : (
                <i className="fas fa-bars"></i>
              )}
            </button>
          </div>
        </div>
      </div>
      {/* Payment Popup */}
      {isPopupVisible && (
        <div className="overlay" onClick={() => setPopupVisible(false)}>
          <div className="overlay-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="close-button"
              onClick={() => setPopupVisible(false)}
            >
              &times;
            </button>
            <h3>Enter Payment Amount</h3>
            <input
              type="number"
              placeholder="Enter amount in INR"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="input-field"
            />
            <button onClick={handlePayment} className="submit-button">
              Proceed to Pay
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
